import { Component, ElementRef, EventEmitter, HostBinding, Inject, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { CalendarEventItem } from 'src/app/models/ExamsAndTasksCalendar/calendarEventItem';
import { LocationSelectPickerComponent } from '../../location-select-picker/location-select-picker.component';
import { DOCUMENT } from '@angular/common';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss', './event-details.component.en.scss'],
})
export class EventDetailsComponent implements OnInit, OnDestroy {
  @Input({ required: true }) event!: CalendarEventItem;
  @Input() notificationsHeaderText: string = '';
  @HostBinding('style.--event-color') @Input() color?: string;
  @HostBinding('class.opened') opened: boolean = false;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('locatinPicker') locatinPicker!: LocationSelectPickerComponent;

  private escListener: any;
  private clickListener: any;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private userAgentService: UserAgentService,
    private eRef: ElementRef
  ) {}

  openedNotifications: boolean = false;

  ngOnInit() {
    setTimeout(() => {
      this.opened = true;

      this.escListener = this.handleEscKey.bind(this);
      window.addEventListener('keydown', this.escListener);
      setTimeout(() => {
        this.clickListener = this.onOutsideClick.bind(this);
        document.addEventListener('click', this.clickListener);
      }, 200);
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.escListener);
  }

  closeEvent() {
    this.opened = false;
    this.close.emit();
  }

  isTimeEmpty(dateTime: string): boolean {
    return dateTime.endsWith('T00:00:00Z');
  }

  openNotifications(e: Event) {
    e.preventDefault();
    this.openedNotifications = true;
    this.changeNotificationPopupMobileStyle(true);
  }

  closeNotifications() {
    this.openedNotifications = false;
    this.changeNotificationPopupMobileStyle(false);
  }

  changeNotificationPopupMobileStyle(opened: boolean) {
    setTimeout(() => {
      let eventPopup = this.document.querySelector(
        '.cal-event-popup'
      ) as HTMLElement;
      let notificationPopup = this.document.querySelector(
        '.notifications-modal'
      ) as HTMLElement;
      if (this.userAgentService.isMobileDevice()) {
        if (opened) {
          this.renderer.setStyle(eventPopup, 'z-index', '999');
          this.renderer.setStyle(notificationPopup, 'z-index', '9999');
        } else {
          if(eventPopup) this.renderer.removeStyle(eventPopup, 'z-index');
        }
      } else {
        if (opened) {
          this.renderer.setStyle(notificationPopup, 'width', '35rem');
          this.renderer.setStyle(notificationPopup, 'text-align', 'justify');
        }
      }
    }, 10);
  }

  private handleEscKey(event: KeyboardEvent): void {
    if (this.opened && (event.key === 'Escape' || event.keyCode === 27)) {
      this.closeEvent();
    }
  }

  onOutsideClick(event: any) {
      if (this.opened && !this.eRef.nativeElement.contains(event.target)) {
          this.closeEvent();
      }
  }
}